module.exports = __webpack_public_path__ + "img/wooden-particle-22.03cd4736.png";